import { Injectable } from '@angular/core';
import { Cidade } from '@tivic-team/manager-ts/dist/grl';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';

@Injectable()
export class CidadeController {

    constructor() { }
    
    async find(filtros?:IFilter):Promise<Array<Cidade>>{	
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/cidades',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Cidade>()
			)
		);
		return await quark.call();
	}

	async get(cdCidade:number):Promise<Cidade>{	
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'grl/cidades/:cdCidade',
					environment: environment,
					pathParams: new JSONData({cdCidade: cdCidade})
				}),
			}),
			new HttpResponse(
				new Object()
			)
        );
        return await quark.call();
	}

	async create(cidade: Cidade):Promise<Cidade>{
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'grl/cidades',
					environment: environment
				}),
				data: new JSONData(cidade)
			}),
			new HttpResponse(
				new Cidade()
			)
		);
		return await quark.call();
	}

	async update(cidade: Cidade):Promise<Cidade>{
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'grl/cidades/:cdCidade', 
					environment: environment, 
					pathParams: new JSONData({cdCidade: cidade.cdCidade})
				}),
				data: new JSONData(cidade)
			}),
			new HttpResponse(
				new Cidade()
			)
		);
		return await quark.call();
	}

}